
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "AudienceInfo": [
      "AudienceCustomerListInfo",
      "AudienceGlobalInfo",
      "AudienceLookalikeInfo",
      "AudiencePixelInfo",
      "AudiencePulseInfo"
    ],
    "AudienceIntegrationConfiguration": [
      "ADFAudienceIntegrationConfiguration",
      "ActivationAudienceIntegrationConfiguration",
      "BeeswaxAudienceIntegrationConfiguration",
      "DisplayVideo360CustomerMatchAudienceIntegrationConfiguration",
      "FacebookCustomAudienceAudienceIntegrationConfiguration",
      "GoogleCustomerMatchAudienceIntegrationConfiguration",
      "HighLevelAudienceIntegrationConfiguration",
      "MadhiveAudienceIntegrationConfiguration",
      "MailchimpAudienceIntegrationConfiguration",
      "S3AudienceIntegrationConfiguration",
      "TealiumAudienceIntegrationConfiguration",
      "ZapierAudienceIntegrationConfiguration"
    ],
    "BaseAdditionsArrayInfo": [
      "CustomerListAdditionsArrayInfo",
      "GlobalAdditionsArrayInfo",
      "PulseAdditionsArrayInfo"
    ],
    "BaseAdditionsInfo": [
      "AudienceCustomerListInfo",
      "AudienceGlobalInfo",
      "AudiencePulseInfo"
    ],
    "BaseAudience": [
      "Audience",
      "RestrictedAccessAudience"
    ],
    "BaseOrganization": [
      "Organization",
      "RestrictedAccessOrganization"
    ],
    "BaseProcessingAdditionInfo": [
      "CustomerListProcessingAdditionInfo",
      "GlobalProcessingAdditionInfo",
      "PulseProcessingAdditionInfo"
    ],
    "BaseRole": [
      "RestrictedAccessRole",
      "Role"
    ],
    "BaseUser": [
      "RestrictedAccessUser",
      "User"
    ],
    "ProcessingResultInfo": [
      "CustomerListInvalidImportData"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AudienceInfo": [
      "AudienceCustomerListInfo",
      "AudienceGlobalInfo",
      "AudienceLookalikeInfo",
      "AudiencePixelInfo",
      "AudiencePulseInfo"
    ],
    "AudienceIntegrationConfiguration": [
      "ADFAudienceIntegrationConfiguration",
      "ActivationAudienceIntegrationConfiguration",
      "BeeswaxAudienceIntegrationConfiguration",
      "DisplayVideo360CustomerMatchAudienceIntegrationConfiguration",
      "FacebookCustomAudienceAudienceIntegrationConfiguration",
      "GoogleCustomerMatchAudienceIntegrationConfiguration",
      "HighLevelAudienceIntegrationConfiguration",
      "MadhiveAudienceIntegrationConfiguration",
      "MailchimpAudienceIntegrationConfiguration",
      "S3AudienceIntegrationConfiguration",
      "TealiumAudienceIntegrationConfiguration",
      "ZapierAudienceIntegrationConfiguration"
    ],
    "BaseAdditionsArrayInfo": [
      "CustomerListAdditionsArrayInfo",
      "GlobalAdditionsArrayInfo",
      "PulseAdditionsArrayInfo"
    ],
    "BaseAdditionsInfo": [
      "AudienceCustomerListInfo",
      "AudienceGlobalInfo",
      "AudiencePulseInfo"
    ],
    "BaseAudience": [
      "Audience",
      "RestrictedAccessAudience"
    ],
    "BaseOrganization": [
      "Organization",
      "RestrictedAccessOrganization"
    ],
    "BaseProcessingAdditionInfo": [
      "CustomerListProcessingAdditionInfo",
      "GlobalProcessingAdditionInfo",
      "PulseProcessingAdditionInfo"
    ],
    "BaseRole": [
      "RestrictedAccessRole",
      "Role"
    ],
    "BaseUser": [
      "RestrictedAccessUser",
      "User"
    ],
    "ProcessingResultInfo": [
      "CustomerListInvalidImportData"
    ]
  }
};
      export default result;
    